import tuggeranongMenu from "./menuData";
import phillipMenu from "./menuData.new";

const menuData = {
	stores: [
		{ id: "tuggeranong", label: "Tuggeranong" },
		{ id: "phillip", label: "Phillip" },
	],
	menus: {
		tuggeranong: tuggeranongMenu,
		phillip: phillipMenu,
	},
};

export default menuData;
